// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3e-eJ","range":"MonthRangeSwitch_range__1_0_9","disabled":"MonthRangeSwitch_disabled__2w3lQ"};